
    (function () {
      const ref = new URLSearchParams(window.location.search).get("ref");
      const EXPIRATION_HOURS = 2;
      const EXPIRATION_MS = EXPIRATION_HOURS * 60 * 60 * 1000; // 2 horas en milisegundos

      async function handleReferral() {
        try {
          // Obtener atributos del carrito
          const cartResponse = await fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });

          const cartData = await cartResponse.json();
          const savedRef = cartData.attributes?.REFERRAL_CODE;
          const savedRefTimestamp = cartData.attributes?.REFERRAL_TIMESTAMP;

          let currentTime = Date.now();
          let shouldUpdateRef = false;
          let newRefCode = null;

          // Verificar si el código guardado ha expirado
          if (savedRef && savedRefTimestamp) {
            const refAge = currentTime - parseInt(savedRefTimestamp);
            
            if (refAge > EXPIRATION_MS) {
              // El código ha expirado, lo eliminamos
              console.log("Código de referido expirado, eliminando...");
              await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  attributes: {
                    REFERRAL_CODE: "",
                    REFERRAL_TIMESTAMP: "",
                  },
                }),
              });
              shouldUpdateRef = true;
            }
          }

          // Si hay un nuevo ref en la URL
          if (ref) {
            // Si es diferente al que ya existe o no hay código guardado
            if (ref !== savedRef || !savedRef || shouldUpdateRef) {
              console.log("Nuevo código de referido detectado:", ref);
              newRefCode = ref;
              shouldUpdateRef = true;
            } else {
              console.log("El código de referido ya existe y no ha expirado");
            }
          } else {
            // No hay ref en URL, verificar si el código guardado sigue válido
            if (savedRef && savedRefTimestamp && !shouldUpdateRef) {
              console.log("Continuando con código de referido existente:", savedRef);
              newRefCode = savedRef;
            }
          }

          // Actualizar el código si es necesario
          if (shouldUpdateRef && newRefCode) {
            await fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                attributes: {
                  REFERRAL_CODE: newRefCode,
                  REFERRAL_TIMESTAMP: currentTime.toString(),
                },
              }),
            });
            console.log("Código de referido actualizado en el carrito:", newRefCode);
          }

        } catch (error) {
          console.error("Error al manejar el código de referido:", error);
        }
      }

      handleReferral();
    })();